export default __webpack_public_path__ + "static/media/WD-T80 80mm thermal receipt printer.14495728.jpg";